// 注意：一定是 exports，不是 export，否则会报错，报错信息是下列的中的内容不是 string
module.exports = {
  home: {
    whatishx: '什么是HyperExchange',
    language: '语言',
    ecoco: '生态合作',
    comself: '社区自治',
    userguide: '用户指南',
    miningguide: '挖矿指南',
    offdoc: '官方文档',
    walletdownload: '钱包下载',
    explore: '区块浏览器',
    page11: '世界是相连的，区块链也是如此',
    page12: 'HyperExchange，真正意义上的第一个跨链项目',
    page21: '跨链，HyperExchange创造了互联互通的区块链世界',
    page22: 'HyperExchange，简称HX，是全球首个支持主链最多、真正落地的跨链项目，已完成BTC、ETH等主流资产的跨',
    page23: '链HX。通过创新的BMT协议不仅已成功接入BTC(包含OMNI)、ETH（包含ERC20）、LTC这样的老牌公链，对之',
    page24: '后出现的新链，也可以很好地支持。通过包容共生建立一个更强大的生态系统，每位成员都享有公平公正的权益，',
    page25: '也为区块链的未来发展带来更多想象空间。',
    page31: '在HX，我可以做什么？',
    page32: 'HX，具有极强的包容性和开放性，让每个成员都可以在这个大生态里',
    page33: '找到属于自己的角色定位，并公平公正地共同享有生态中的权益。',
    page34: '挖矿与收益',
    page35: '如果您想参与到HX的生态并获得持续的收益，您可以选择挖矿。只要持有任何一种已支持的跨链资产，都可以参与挖矿。你可以选择成为矿工，或是选择通过持币权重参与投票资产的方式，让矿工替你挖矿，都可以获得一定的出块收益。',
    page36: '了解如何挖矿？',
    page37: '竞选与管理',
    page38: '如果您想参与到HX系统的管理中，并愿意共同规划HX的未来发展。您可以通过竞选的方式，成为HX的最高管理者senator之一，所有认同HX治理理念以及符合条件者，都可以参与公开竞选。在拥有责任的同时，您也将获得一定的社区分红作为服务的激励。',
    page39: '了解竞选信息？',
    page310: '交易与分红',
    page311: '所有持币用户，都可以自由地进行交易。HX提供了安全可靠透明的链上交易所，您可以在这里完成不同资产的价值兑换。如果您持有10000以上的HX，还可以不定时收到来自系统的分红奖励。',
    page312: '开发与应用',
    page313: '如果您是开发爱好者，这里有完善的开发工具和SDK供您使用，可以开发属于自己的智能合约或DAPP应用等。如果您是第三方平台，想要接入HX体系，这里也有相应的文档及开发规范供您参考。了解更多信息，可到官方文档中查询',
    page314: '进入官方文档',
    page41: '链上自治，将古典民主政体与区块链元素相结合的首次尝试',
    page42: 'HX，通过参考民主政体制度，融入区块链元素，形成了一套民主而高效的社区自治制度。通过多个角色共同维护',
    page43: '社区的健康运行。相互制衡，和谐发展，很好地解决了以往模式存在的意见分歧等问题，从而团结更多的社区，共',
    page44: '同为区块链的发展做出贡献。',
    page51: '智能合约，灵活创建应用，一键发布',
    page52: '为了便于开发者高效工作，HX团队在官方平台为大家提供了丰富的SDK。同时， 完善的智能合约工具，提供了无限',
    page53: '可拓展性，也让全球开发者得以快速开发属于自己的应用，目前，HX上已经发布了一些合约模板供用户使用，',
    page54: '比如一键发币、STO应用、智能锁仓、挂单求购等。',
    page55: '交易所',
    page56: '基于智能合约，HX提供了链上交易所功能，跨链交易一键即达。实现全球数字资产的链上自由交易，快速挂单自动撮合，数据公开透明，所有交易链上可查询。为了便于用户使用，提供了灵活的手续费支付方式。',
    page57: 'DAPP应用',
    page58: '跨链为HX的DAPP生态提供了新的资产凭证HX，为DAPP生态发展提供了广阔的想象空间，所有HX的成员共享生态资源与系统优势，快速完成应用开发。为了提供开发效率，简化流程，完善的SDK及IDE工具，面向全球开发者免费使用。',
    page59: '金融衍生服务',
    page510: '依靠HX独有的跨链抵押模型，HX链上沉淀了海量的数字货币，基于存量资金，可以通过资产投票再抵押机制，快速盘活资金，衍生出借贷，理财等多样性的金融产品。',
    page511: '丰富的智能合约代币模板，一键发行代币。多币种平台，天然支持多币种众筹与空投。快速实现资产token化，降低企业及机构募资门槛和难度',
    page61: 'HX生态，欢迎你的加入',
    page62: '这里是已有的部分生态项目列表，我们的家族还在不断扩大。',
    page63: '查看更多',
    page64: '官方PC钱包',
    page65: '手机钱包',
    page66: 'PC钱包',
    page67: '官方PC客户端，功能完善',
    page68: '官方推荐手机钱包，支持挖矿',
    page69: '官方去中心化交易所',
    page70: '网页插件钱包',
    page71: 'HX合作交易所',
    page72: 'HX合作钱包',
    page73: '智能合约开发IDE',
    page74: '交易所',
    page75: '网页钱包',
    page76: '币赢网',
    page77: '更多视频',
    page78: '了解HX',
    news: '资讯',
    videointro: '视频介绍',
    annocenter: '公告中心',
    videoin: '视频介绍',
    contactus: '联系我们',
    qqgroup: 'QQ交流群',
    hxvideo1: 'HX动画视频--第1集',
    hxvideo2: 'HX动画视频--第2集',
    video2_title: 'HX跨链机制是如何实现的'
  },
  ecosystem: {
    email: '邮箱：',
    wechat: '客服微信',
    member: '生态成员',
    intro1: 'HX，具有极强的包容性和开放性，让每个成员都可以在这个大生态里',
    intro2: '找到属于自己的角色定位，并公平公正地共同享有生态中的权益。',
    intro3: '如果你想加入我们，请和我们联系。',
    join: '如何加入HX生态？',
    recommendation: '推荐应用',
    indicator: '官方PC钱包—Indicator',
    indicator_intro: 'Indicator是HX官方PC钱包，支持HX的所有功能。用户可在钱包中进行注册、存储、充值、提现、币币兑换、交易、citizen注册、提案、投票等一系列操作。可通过PC钱包进行独立挖矿并领取收益。',
    anybit: '官方推荐手机钱包 — AnyBit',
    anybit_intro: 'AnyBit是一个多链去中心化钱包，目前支持BTC、ETH、LTC、HC、NEO、DCR、AE、NULS、USDT、ECR20、HX等数十条主链币种，并是首个且独家支持HX质押挖矿的手机钱包。',
    hdex: '官方去中心化交易所—HDEX',
    hdex_intro: 'HX官方去中心化交易所DAPP，可实现不同资产的跨链交易，安全可靠，信息公开透明。',
    hoo_intro: '手机钱包，支持HX场外交易',
    web_wallet: '网页钱包',
    web_wallet_intro: '无需安装，直接使用，私钥本地保存',
    ide: 'IDE',
    ide_intro: '智能合约集成开发环境，支持单步调试及合约链上测试',
    zg_intro: '比特币中国投资交易所',
    zb_intro: 'ZB全球数字资产交易所',
    excraft_intro: '香港交易所',
    bitasset_intro: '台湾交易所',
    ceo_intro: 'CEO 交易所',
    coinw_intro: '币赢全球交易所',
    be_intro: '币易交易所，HX议员',
    draperdragon: '德鼎创新',
    draperdragon_intro: '投资机构, HX 议员',
    eightdecimal: '八维资本',
    eightdecimal_intro: '投资机构, HX 议员',
    tag_ex: '交易所',
    tag_investor: '投资机构',
    tag_wallet: '钱包',
    tag_dev: '开发工具',
    qbtc: 'QBTC',
    qbtc_intro: '多币种数字资产交易平台',
    hb: '汇币网',
    hb_intro: '汇币，为汇聚价值区块链代币而生。努力为您打造安全可靠的交易平台。'
  },
  summary: {
    roadmap: '历  程',
    slogan: '我们会坚守我们的理想，并在研究、科技发展、市场推广、社区参与等方面不断改善我们的运作。',
    fee: '手续费灵活性',
    fee_intro: 'HyperExchange链上的手续费可以是HX,也支持多种HIOU支付，让用户拥有HX或者任意一种HIOU都可以直接进行交易，而不需要关心手续费的问题。HyperExchange上手续费兑换比率并不是固定比例，而是由市场动态决定。随着HyperExchange资产价格的波动，交易所需的HIOU也会上下波动。',
    smart_contract: '智能合约',
    smart_contract_intro: 'HyperExchange用户通过使用图灵完备的智能合约，可以灵活扩展定制复杂的业务逻辑，以及复杂金融合约等，同时在不对原链本身代码修改更新的基础上，实现有限制可控地动态扩展功能。例如，在HyperExchange上通过智能合约可以实现：Token合约，交易合约，锁仓合约，各种DAPP合约等。',
    efficiency: '高效',
    efficiency_intro: 'HX主链每5秒产出一个块，相对于BTC每10分钟一个块和LTC每2.5分钟一个块，交易确认速度有了显著的提升。在HyperExchange主链上进行BTC或LTC资产转移或者交易时的性能分别约为BTC主链的120倍，LTC的30倍。HX理论TPS（每秒处理交易数）值达到1万,足以承载多条链上的高负荷交易。',
    reserve: '百分百准备金',
    reserve_intro: '为了确保HCASH生态系统的稳定和安全，HyperExchange的准备金比率为百分百，每个HIOU都有一个真实的原链资产（如BTC、ETH）质押在原链上由POV共识管理的多重签名冷热钱包里。确保HX所有资产都不会凭空增加或销毁，每一个资产的增加或减少都一一对应着用户在原链上资产的充值或提现。',
    crosschain: '跨链互通互联',
    crosschain_intro1: 'HyperExchange通过创新的Blockchain Multi Tunnel(BMT)协议率先实现了区块链间价值互通互联。',
    crosschain_intro2: '跨链功能的实现，对当前的区块链领域有着重大的意义。',
    crosschain_intro3: '目前已支持的链有：',
    crosschain_intro4: 'BTC、ETH、BTM、LTC、USDT、PAX、ELF、HC',
    features: '主要特性',
    intro1: 'HyperExchange是一条率先实现区块链间价值互通互联的公有链。',
    intro2: 'HX指HyperExchange链上的功能代币，同时也是HyperExchange链的简称。',
    intro3: 'HIOU指HyperExchange上对应锚定的其他资产链数字资产。',
    intro4: '例如HXBTC指HyperExchange上对应锚定的比特币资产。'
  },
  mining: {
    pc_guide_url: 'http://docs.hx.cash/zh/wallets/hxindicator-using-citizen/',
    miner_guide_url: 'https://mp.weixin.qq.com/s?__biz=Mzg4MzE0OTY3Mg==&mid=2247483736&idx=1&sn=8f29ae4ee46a694aa35a9a2e18bc245a&chksm=cf4a9f5ff83d1649490b28a37e6755ca39d6fb09849251a0946660c4ef5fde18e41836b50eea&token=741945701&lang=zh_CN#rd',
    citizen_guide_pc: 'Citizen挖矿指南',
    citizen_independent: '我想成为独立矿工',
    citizen_independent1: '成为一名Citizen，就可以成为独立矿工，通过挖矿可以获得源源不断的收益。想要成为矿工，',
    citizen_independent2: '需要消耗1000个HX作为门槛，这笔资金一旦注册将在链上直接销毁。然后下载PC端钱包，准备好你的挖矿道具，',
    citizen_independent3: '当然想要成为值得信任的矿工，你还需要肩负一定的责任，比如：客户端24小时实时在线、获得更高的资产',
    citizen_independent4: '权重支持。得到更多的小伙伴资产权重支持，可以让你拥有更高的出块概率。',
    citizen_independent5: '下面这份指南，将告诉你如何成为一名合格的Citizen。',
    citizen_sign_up: '注册账号',
    citizen_register: '注册Citizen',
    citizen_invite: '邀请用户投票',
    user_guide: '不想当矿工，可以投票挖矿',
    user_guide_detail1: '如果你不想花费1000个HX，也不想下载PC钱包24小时实时在线，没关系，你可以选择通过持币权重参与投票挖矿，只要下载手机钱包，随时随地都能挖矿。只要你拥有HX链上所支持的任何一种或多种资产，都可以参与挖矿。在选择Citizen的时候，一定要注意综合考虑他的稳定性、佣金比例以及获得权重支持情况等因素，选择一个靠谱的矿工，也可以让自己天天坐享收益。',
    user_guide_detail2: '下面这份指南，将告诉你如何加入到投票挖矿以及选择合适的矿工。',
    user_guide_mobile: '手机挖矿指南',
    download_anybit: '下载AnyBit',
    weighted_vote: '权重投票',
    choose_citizen: '选择Citizen',
    user_register: '注册',
    miner1: '/static/img/miner_zh1.png',
    miner2: '/static/img/miner_zh2.png',
    miner3: '/static/img/miner_zh3.png',
    miner4: '/static/img/miner_zh4.png',
    citizen1: '/static/img/citizen_zh1.png',
    citizen2: '/static/img/citizen_zh2.png',
    citizen3: '/static/img/citizen_zh3.png'
  },
  download: {
    pc: 'PC 下载',
    pc_intro1: 'Indicator是官方指定的PC端全节点重钱包，支持HX全部功能。用户可完成注册、挖矿、充值、提现、兑换、一键发币、Citizen注册、提案、投票等功能。具体功能开放请根据客户端更新为主。',
    pc_intro2: '注：',
    pc_intro3: '1.请及时进行钱包备份，并保持更新。',
    pc_intro4: '2.PC客户端需要同步非常大量的数据，这会消耗一定的性能以及资源，并且需要24小时实时在线，你可以选择使用手机钱包去挖矿，也可以完成充值、提现等功能。',
    pc_intro5: '3.Lite版本的钱包无需下载区块数据，但是会消耗一定的网络带宽请求官方区块节点的数据。私钥仍然保存在本地。',
    mobile: 'APP 下载',
    mobile_intro1: 'AnyBit是一个支持BTC、ETH、LTC、HC、NEO、DCR、NULS、USDT、ERC20、HX及其多资产等多种主流币种的去中心化钱包。特点如下：',
    mobile_intro2: '1、去中心化安全存储，支持冷热钱包',
    mobile_intro3: '2、支持HC/DCR PoS挖矿',
    mobile_intro4: '3、支持行情实时查看',
    mobile_intro5: '4、HX及其链上资产投票挖矿',
    mobile_intro6: '注意：AnyBit支持HX投票挖矿的全部功能，以及跨链充值和提现。手机链上挖矿更方便，无需实时在线，一键挖矿领取收益，随时赎回和追加。',
    mobile_pic: '/static/img/download_wallet_mobile_zh.png',
    wallet_pic: '/static/img/download_wallet_pc_zh.png'
  },
  announcement: {
    title_1: 'HX上线台湾交易所BitAsset',
    content_1: 'BitAsset将于香港时间5月10日15：00上线HyperExchange，开放HX/CNYT、HX/USDT交易市场，HyperExchange (HX) 充提业务现已开放，欢迎交易体验。BitAsset交易所是台湾地区知名数字货币交易所，网址为: https://www.bitasset.com/',
    title_2: 'HX宣传视频第一集正式发布',
    content_2: '本集视频从总体上介绍了HX的主要特性，比较适合初次接触HX的用户对HX项目有一个全面的了解。',
    read_all: '阅读全文',
    pack_up: '收起'
  }
}



// WEBPACK FOOTER //
// ./src/i18n/lang/zh.js